import * as React from "react";
import { Actions, Container, FormWrapper } from "./ProfileForm.styled";
import { Button, InputField } from "../../../common";
import { useFormik } from "formik";
import { observer } from "mobx-react";
import { useStores } from "../../../../stores";
import { removeEmoji } from "../../../../helpers";
import { useTranslation } from "react-i18next";
import { ButtonTheme } from "../../../../constants";
import { useNavigate } from "react-router-dom";

export const ProfileForm = observer(() => {
	const { authStore, notificationsStore } = useStores();
	const { userStore } = authStore;

	const { t } = useTranslation();
	const navigate = useNavigate();

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			first_name: userStore.first_name,
			last_name: userStore.last_name,
			country: userStore.country,
			city: userStore.city,
			education: userStore.education,
			music_education: userStore.music_education,
		},
		onSubmit: async (values) => {
			try {
				values.first_name = removeEmoji(values.first_name);
				values.last_name = removeEmoji(values.last_name);

				// Обновление профиля
				await userStore.update(values);

				// Уведомление о успешном обновлении
				notificationsStore.add({
					title: "Profile updated successfully",
				});
			} catch (e: any) {
				notificationsStore.error({
					message: e.errors.join("<br/>"),
				});
			}
		},
	});

	const handleOnDeleteAccount = async () => {
		const isConfirm = window.confirm(t("notifications.delete_account"));
		if (!isConfirm) {
			return;
		}
		try {
			await authStore.deleteAccount();

			authStore.signOut();

			notificationsStore.add({
				title: t("notifications.titles.accountDeleted"),
			});
			navigate("/", { replace: true });
		} catch (error) {
			console.error("handleOnDeleteAccount error:", error);
			notificationsStore.error({
				message: t("notifications.message.accountDeleteFailed"),
			});
		} finally {
		}
	};

	return (
		<Container>
			<FormWrapper onSubmit={formik.handleSubmit}>
				<InputField
					small
					label={"Name"}
					name={"first_name"}
					defaultValue={formik.values.first_name}
					onChange={formik.handleChange}
					placeholder={"Your name"}
				/>

				<InputField
					small
					label={"Last Name"}
					name={"last_name"}
					defaultValue={formik.values.last_name}
					onChange={formik.handleChange}
					placeholder={"Your last name"}
				/>

				<InputField
					small
					label={"Country"}
					name={"country"}
					defaultValue={formik.values.country}
					onChange={formik.handleChange}
					placeholder={"Your country"}
				/>

				<InputField
					small
					label={"City"}
					name={"city"}
					defaultValue={formik.values.city}
					placeholder={"Your city"}
					onChange={formik.handleChange}
				/>

				<InputField
					small
					label={"Education"}
					name={"education"}
					defaultValue={formik.values.education}
					onChange={formik.handleChange}
					placeholder={"Your education"}
				/>

				<InputField
					small
					label={"Music Education"}
					name={"music_education"}
					defaultValue={formik.values.music_education}
					onChange={formik.handleChange}
					placeholder={"Your music education"}
				/>
				<Actions data-action>
					<Button theme={ButtonTheme.RED} onClick={handleOnDeleteAccount}>
						{t("buttons.actions.delete_account")}
					</Button>
					<Button type={"submit"}>{t("buttons.actions.update_account")}</Button>
				</Actions>
			</FormWrapper>
		</Container>
	);
});
